import { useEffect } from 'react';

/** @description 현재 포커스된 요소를 화면 중앙으로 스크롤 처리하는 커스텀훅 */
export const useScrollActiveElement = () => {
  useEffect(() => {
    window.onresize = () => {
      setTimeout(() => {
        scrollActiveElement();
      }, 400);
    };
    return () => {
      window.onresize = null;
    };
  }, []);

  const scrollActiveElement = () => {
    const currentActiveElement = document.activeElement as HTMLElement;

    if (currentActiveElement) {
      currentActiveElement.focus({ preventScroll: true });
      currentActiveElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return { scrollActiveElement };
};
